import React from 'react'
import styles from "../ContactLanding/ContactLanding.module.css"
import Navbar from '../../Navbar/Navbar'
import {Row,Col} from 'react-bootstrap'
import img from "../../assets/20.png"
import ContactAbout from "../About/ContactAbout"
export default function ContactLanding() {
  return (
    <div  className={styles.ladningbg} >
    <Navbar/>
      {/* <div className={styles.containerRow}>
      
      <h2 className={styles.contactHeading}>Get in Touch</h2>
      <p className={styles.contactDescription}>
        We'd love to hear from you. Whether you have a question about features, pricing, or anything else — our team is ready to help.
      </p>

      <div className={styles.contactDetails}>
        <p><strong>Email:</strong> contact@example.com</p>
        <p><strong>Phone:</strong> +1 (555) 123-4567</p>
        <p><strong>Address:</strong> 123 Business Street, New York, NY</p>
      </div>
    </div> */}
    <div style={{display:"flex",justifyContent:"center",alignItems:"center",height:"100%"}}>
        <div className={styles.containerCol1}>
          <h3 style={{color:"#07448E",fontFamily:"'Inter', sans-serif"}}>Contact Us</h3>
        </div>
         <div className={styles.containerCol2}>
          <img src={img}   />
         </div>
         </div>

        
      
    </div>
  )
}
